import React from 'react'
const TrainingVideoHeader = ({ data }: any) => {
    return (
        <div className="TrainingVideoHeader-Background" >
            <div className="container">
                <h1 className="TrainingVideoHeader-h1">Video Library</h1>
                <hr className="TraingingVideoHeader-hr" />
            </div>
        </div>
    )
}

export default TrainingVideoHeader
